"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
/**
 * Wraps child component to provide a label and display errors for
 * a field
 */
var FormGroup = /** @class */ (function (_super) {
    tslib_1.__extends(FormGroup, _super);
    function FormGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroup.prototype.getTagText = function () {
        if (this.props.tagOptional) {
            return I18n.t('commons.formGroup.optional');
        }
        if (this.props.tagRecommended) {
            return I18n.t('commons.formGroup.recommended');
        }
        if (this.props.tagRequired) {
            return I18n.t('commons.formGroup.required');
        }
    };
    FormGroup.prototype.renderTag = function () {
        if (!this.getTagText())
            return;
        return (React.createElement("div", { className: "form-group__tag" }, this.getTagText()));
    };
    FormGroup.prototype.renderError = function () {
        if (!this.props.errorText)
            return;
        return (React.createElement("div", { className: "form-group__error size-80 mt-half" }, this.props.errorText));
    };
    FormGroup.prototype.render = function () {
        var classes = classNames('form-group', { 'form-group--with-error': !!this.props.errorText });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", { htmlFor: this.props.inputName || null, className: "form-group__label-text" }, this.props.label),
                this.renderTag()),
            React.createElement("div", { className: "form-group__fields" },
                this.props.children,
                this.renderError(),
                !!this.props.helpText &&
                    React.createElement("div", { className: "form-group__help-text" }, this.props.helpText))));
    };
    return FormGroup;
}(React.Component));
exports.default = FormGroup;
//# sourceMappingURL=form_group.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/form_group.js
// module id = u4QT
// module chunks = 20 21 22